import { v } from "convex/values";
import {
  internalControl,
  defineTableWithInternalControl,
} from "../../../lib/shared/validators";
import { customFieldValues } from "../../custom_fields";

export const equipmentType = v.union(
  v.literal("vehicle"),
  v.literal("tool"),
  v.literal("machinery"),
  v.literal("other"),
);

export const equipmentStatus = v.union(
  v.literal("available"),
  v.literal("in_use"),
  v.literal("maintenance"),
  v.literal("retired"),
);

export const validatorEquipment = v.object({
  name: v.string(),
  type: equipmentType,
  identifier: v.optional(v.string()),
  description: v.optional(v.string()),
  status: v.optional(equipmentStatus),
  specifications: v.optional(v.any()),
  acquisitionCost: v.optional(v.number()),
  acquisitionDate: v.optional(v.number()),
  notes: v.optional(v.string()),
  internalControl,
  /** Valores de campos personalizados (Colecciones), por key de definición. */
  customFields: v.optional(customFieldValues),
});

export const equipment = defineTableWithInternalControl(validatorEquipment)
  .index("by_type", ["type"])
  .index("by_company_and_type", ["internalControl.companyId", "type"])
  .index("by_branch_and_type", ["internalControl.branchId", "type"])
  .index("by_identifier", ["identifier"])
  .searchIndex("search_equipment", {
    searchField: "name",
    filterFields: ["internalControl.companyId", "internalControl.branchId"],
  });
